import React, { useEffect, useState } from "react"
import { FetchHandler } from "../../Handlers/FetchHandler";
import { MessageBoxes } from "../../Handlers/MessageBoxes";
import { useReduxState } from "../../hooks/reduxHook";
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon";
import { CustomColumnContainer, ThreeColumnContainer, TwoColumnContainer } from "../Shared/Formelements";
import { LoadingBar, ScreenHeader, ScreenMenu } from "../UI/Elements";
import { useStatisticsMenu } from "./useStatisticsMenu";
import { useDateHelper } from "../../hooks/useHelper";
import { DateFormatter } from "../../Handlers/Helpers";




export const SubscriptionStatistics = () => {


    const menu = useStatisticsMenu();

    return (
        <div>
            <ScreenHeader text="Statistik" icon={AdminIcons.chart} />
            <ScreenMenu items={menu?.items} />
            <SubscriptionStats />

        </div>
    )
}

const SubscriptionStats = () => {

    const ui = useCityStats();



    const toPercent = (n: number) => {
        return n ? (Math.round(10 * n) / 10) + "%" : "";
    }
    const addSpacer = (n: number) => {
        return !n ? "" : n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }




    return (

        <div>
            <h2>
                Prenumerationer per dag
            </h2>

            <LoadingBar loading={ui.loading} />
            <TwoColumnContainer>
                <div style={{ paddingRight: "50px" }}>
                    <table className="tbl">
                        <thead>
                            <tr>
                                <th>
                                    Datum
                                </th>
                                <th style={{ textAlign: "right" }}>
                                    Månatliga pren.
                                </th>
                                <th style={{ textAlign: "right" }}>
                                    Årliga pren.
                                </th>
                                <th style={{ textAlign: "right" }}>
                                    Totalt
                                </th>
                                <th style={{ textAlign: "right" }}>
                                    Diff
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {ui.data && ui.data?.map((s, idx) => (
                                <tr key={s.datekey}>
                                    <td>
                                        {DateFormatter.dateKeyToDate(s?.datekey)} : {DateFormatter.dateKeyToDayInWeek(s?.datekey)}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {s?.monthly_subs}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {s?.yearly_subs}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {s?.yearly_subs + s?.monthly_subs}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {s?.diff}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>
                <div>

                    <div>
                        <table className="tbl" style={{ maxWidth: "350px" }}>
                            <thead>
                                <tr>
                                    <th>
                                        Månad
                                    </th>
                                    <th>
                                        Skillnad
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {ui.dataAggr?.filter((f, idx) => idx < (ui.dataAggr?.length - 1))?.map(p => (
                                    <tr key={p.monthkey}>
                                        <td>{p.monthkey}</td>
                                        <td>{p.diff > 0 ? "+" + p.diff : p.diff}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </TwoColumnContainer>
        </div>
    )

}


type SubsDataType = {
    datekey: number
    monthkey: number
    monthly_subs: number
    yearly_subs: number,
    diff?: string;
}

const useCityStats = () => {

    const [data, setData] = useState<SubsDataType[]>([]);
    const [dataAggr, setDataAggr] = useState<{ monthkey: string, diff: number }[]>([]);

    useEffect(() => {
        FetchHandler.getJson("/api/stats/subs").then((s: SubsDataType[]) => {
            let a = [...s];
            a.sort((a, b) => {
                if (a?.datekey < b?.datekey) { return 1; }
                if (a?.datekey > b?.datekey) { return -1; }
                return 0;
            });
            let agg = {};
            for (var i = 0; i < a.length; i++) {
                var today = a[i].monthly_subs + a[i].yearly_subs;
                var yesterday = (a[i + 1]?.monthly_subs ?? 0) + (a[i + 1]?.yearly_subs ?? 0);
                if (!yesterday) {
                    a[i].diff = "-";
                } else {
                    a[i].diff = today > yesterday ? "+" + (today - yesterday) : (today - yesterday).toString();
                }
                a[i].monthkey = parseInt(a[i].datekey.toString().substring(0, 6));

                agg[a[i].monthkey] = (agg[a[i].monthkey] ?? 0) + (today - yesterday);

            }
            let aggr = Object.keys(agg)?.map((key, i) => { return { monthkey: key, diff: agg[key] }; });
            aggr.sort((a, b) => {
                if (a.monthkey > b.monthkey) { return -1; }
                else if (a.monthkey < b.monthkey) { return 1; }
                else { return 0; }
            })
            setDataAggr(aggr);

            setData(a);
        });
    }, []);


    return {
        loading: false,
        data: data,
        dataAggr: dataAggr,
    }
}


